// Author Lin
// Date 2021-11-20 16:44:10

class MintalMesPrdSmeltingSubstationRecord {
        constructor({
                id = null,
                recordTime = '',
                locationId = '',
                locationName = '',
                furnaceId = '',
                furnaceName = '',
                mainVoltageOne = '',
                mainVoltageTwo = '',
                mainVoltageThree = '',
                mainCurrentOne = '',
                mainCurrentTwo = '',
                mainCurrentThree = '',
                mainCurrent301 = '',
                mainCurrent302 = '',
                mainCurrent303 = '',
                tapPosition301 = '',
                tapPosition302 = '',
                tapPosition303 = '',
                oilTemp301 = '',
                oilTemp302 = '',
                oilTemp303 = '',
                secondCurrent301 = '',
                secondCurrent302 = '',
                secondCurrent303 = '',
                tertiaryCurrent301 = '',
                tertiaryCurrent302 = '',
                tertiaryCurrent303 = '',
                electrodeCurrent301 = '',
                electrodeCurrent302 = '',
                electrodeCurrent303 = '',
                bathVoltage301 = '',
                bathVoltage302 = '',
                bathVoltage303 = '',
                voltage301 = '',
                voltage302 = '',
                voltage303 = '',
                voltageU1u2 = '',
                voltageU2u3 = '',
                voltageU3u1 = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.recordTime = recordTime;
            this.locationId = locationId;
            this.locationName = locationName;
            this.furnaceId = furnaceId;
            this.furnaceName = furnaceName;
            this.mainVoltageOne = mainVoltageOne;
            this.mainVoltageTwo = mainVoltageTwo;
            this.mainVoltageThree = mainVoltageThree;
            this.mainCurrentOne = mainCurrentOne;
            this.mainCurrentTwo = mainCurrentTwo;
            this.mainCurrentThree = mainCurrentThree;
            this.mainCurrent301 = mainCurrent301;
            this.mainCurrent302 = mainCurrent302;
            this.mainCurrent303 = mainCurrent303;
            this.tapPosition301 = tapPosition301;
            this.tapPosition302 = tapPosition302;
            this.tapPosition303 = tapPosition303;
            this.oilTemp301 = oilTemp301;
            this.oilTemp302 = oilTemp302;
            this.oilTemp303 = oilTemp303;
            this.secondCurrent301 = secondCurrent301;
            this.secondCurrent302 = secondCurrent302;
            this.secondCurrent303 = secondCurrent303;
            this.tertiaryCurrent301 = tertiaryCurrent301;
            this.tertiaryCurrent302 = tertiaryCurrent302;
            this.tertiaryCurrent303 = tertiaryCurrent303;
            this.electrodeCurrent301 = electrodeCurrent301;
            this.electrodeCurrent302 = electrodeCurrent302;
            this.electrodeCurrent303 = electrodeCurrent303;
            this.bathVoltage301 = bathVoltage301;
            this.bathVoltage302 = bathVoltage302;
            this.bathVoltage303 = bathVoltage303;
            this.voltage301 = voltage301;
            this.voltage302 = voltage302;
            this.voltage303 = voltage303;
            this.voltageU1u2 = voltageU1u2;
            this.voltageU2u3 = voltageU2u3;
            this.voltageU3u1 = voltageU3u1;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new MintalMesPrdSmeltingSubstationRecord();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recordTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.recordTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.locationId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.locationName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.furnaceId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.furnaceName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'mainVoltageOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.mainVoltageOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'mainVoltageTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.mainVoltageTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'mainVoltageThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.mainVoltageThree',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'mainCurrentOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.mainCurrentOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'mainCurrentTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.mainCurrentTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'mainCurrentThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.mainCurrentThree',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'mainCurrent301',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.mainCurrent301',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'mainCurrent302',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.mainCurrent302',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'mainCurrent303',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.mainCurrent303',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'tapPosition301',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.tapPosition301',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'tapPosition302',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.tapPosition302',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'tapPosition303',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.tapPosition303',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'oilTemp301',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.oilTemp301',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'oilTemp302',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.oilTemp302',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'oilTemp303',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.oilTemp303',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'secondCurrent301',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.secondCurrent301',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'secondCurrent302',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.secondCurrent302',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'secondCurrent303',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.secondCurrent303',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'tertiaryCurrent301',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.tertiaryCurrent301',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'tertiaryCurrent302',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.tertiaryCurrent302',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'tertiaryCurrent303',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.tertiaryCurrent303',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'electrodeCurrent301',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.electrodeCurrent301',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'electrodeCurrent302',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.electrodeCurrent302',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'electrodeCurrent303',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.electrodeCurrent303',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bathVoltage301',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.bathVoltage301',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bathVoltage302',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.bathVoltage302',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bathVoltage303',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.bathVoltage303',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'voltage301',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.voltage301',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'voltage302',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.voltage302',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'voltage303',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.voltage303',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'voltageU1u2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.voltageU1u2',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'voltageU2u3',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.voltageU2u3',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'voltageU3u1',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.voltageU3u1',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            recordTimeRteFilter : '',
            recordTimeLteFilter : '',
            locationIdFilter : '',
            locationNameFilter : '',
            furnaceIdFilter : '',
            furnaceNameFilter : '',
            mainVoltageOneFilter : '',
            mainVoltageTwoFilter : '',
            mainVoltageThreeFilter : '',
            mainCurrentOneFilter : '',
            mainCurrentTwoFilter : '',
            mainCurrentThreeFilter : '',
            mainCurrent301Filter : '',
            mainCurrent302Filter : '',
            mainCurrent303Filter : '',
            tapPosition301Filter : '',
            tapPosition302Filter : '',
            tapPosition303Filter : '',
            oilTemp301Filter : '',
            oilTemp302Filter : '',
            oilTemp303Filter : '',
            secondCurrent301Filter : '',
            secondCurrent302Filter : '',
            secondCurrent303Filter : '',
            tertiaryCurrent301Filter : '',
            tertiaryCurrent302Filter : '',
            tertiaryCurrent303Filter : '',
            electrodeCurrent301Filter : '',
            electrodeCurrent302Filter : '',
            electrodeCurrent303Filter : '',
            bathVoltage301Filter : '',
            bathVoltage302Filter : '',
            bathVoltage303Filter : '',
            voltage301Filter : '',
            voltage302Filter : '',
            voltage303Filter : '',
            voltageU1u2Filter : '',
            voltageU2u3Filter : '',
            voltageU3u1Filter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'recordTimeRteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.filter.recordTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'recordTimeLteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.filter.recordTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'locationNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.filter.locationName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'furnaceNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.filter.furnaceName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'recordTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.recordTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.locationName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.furnaceName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,required: true
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
                {
                key: 'mainVoltageOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.mainVoltageOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'mainVoltageTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.mainVoltageTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'mainVoltageThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.mainVoltageThree',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'mainCurrentOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.mainCurrentOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'mainCurrentTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.mainCurrentTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'mainCurrentThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.mainCurrentThree',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'mainCurrent301',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.mainCurrent301',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'mainCurrent302',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.mainCurrent302',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'mainCurrent303',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.mainCurrent303',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'tapPosition301',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.tapPosition301',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'tapPosition302',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.tapPosition302',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'tapPosition303',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.tapPosition303',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'oilTemp301',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.oilTemp301',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'oilTemp302',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.oilTemp302',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'oilTemp303',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.oilTemp303',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'secondCurrent301',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.secondCurrent301',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'secondCurrent302',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.secondCurrent302',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'secondCurrent303',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.secondCurrent303',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'tertiaryCurrent301',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.tertiaryCurrent301',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'tertiaryCurrent302',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.tertiaryCurrent302',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'tertiaryCurrent303',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.tertiaryCurrent303',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'electrodeCurrent301',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.electrodeCurrent301',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'electrodeCurrent302',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.electrodeCurrent302',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'electrodeCurrent303',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.electrodeCurrent303',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bathVoltage301',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.bathVoltage301',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bathVoltage302',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.bathVoltage302',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bathVoltage303',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.bathVoltage303',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'voltage301',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.voltage301',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'voltage302',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.voltage302',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'voltage303',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.voltage303',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'voltageU1u2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.voltageU1u2',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'voltageU2u3',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.voltageU2u3',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'voltageU3u1',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.voltageU3u1',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingSubstationRecord.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {MintalMesPrdSmeltingSubstationRecord, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        